import type { MultilingualQuestion } from '../../types/multilingualQuestion';

// Multilingual version of Speed Limits questions
export const speedLimitsMultilingual: MultilingualQuestion[] = [

  {
    id: 'q-sl-1',
    text: {
      en: 'What is the maximum speed limit on a motorway in the Netherlands during normal conditions?',
      nl: 'Wat is de maximumsnelheid op een snelweg in Nederland onder normale omstandigheden?',
      ar: 'ما هو الحد الأقصى للسرعة على طريق سريع في هولندا في ظروف طبيعية؟'
    },
    options: [
      { id: 'q-sl-1o1', text: { en: '80 km/h', nl: '80 km/u', ar: '80 كم/س' } },
      { id: 'q-sl-1o2', text: { en: '100 km/h', nl: '100 km/u', ar: '100 كم/س' } },
      { id: 'q-sl-1o3', text: { en: '120 km/h', nl: '120 km/u', ar: '120 كم/س' } },
      { id: 'q-sl-1o4', text: { en: '130 km/h', nl: '130 km/u', ar: '130 كم/س' } }
    ],
    correctAnswerId: 'q-sl-1o2',
    explanation: {
      en: 'Since March 2020, the standard maximum speed on Dutch motorways is 100 km/h. This applies day and night. On specific sections 130 km/h is permitted between 19:00 and 06:00 where posted. (RVV 1990 art. 98)',
      nl: 'Sinds maart 2020 is de standaard maximumsnelheid op Nederlandse snelwegen 100 km/u. Dit geldt dag en nacht. Op specifieke trajecten is 130 km/u toegestaan tussen 19:00 en 06:00 waar dit wordt aangegeven. (RVV 1990 art. 98)',
      ar: 'منذ مارس 2020، الحد الأقصى القياسي للسرعة على الطرق السريعة الهولندية هو 100 كم/س. وينطبق ذلك ليلا ونهارا. في بعض المقاطع يسمح بـ 130 كم/س بين 19:00 و06:00 حيث يشار إلى ذلك. (RVV 1990 فن. 98)'
    },
    subject: 'Speed Limits',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/speed-limits/speed-1-motorway-100-good-weather.jpg'
  }
];
